export default __webpack_public_path__ + "e69d59a679aac26e0df294296ff0b980.svg";